const getNonce = require("@nn/psdl-utility/src/nonce").default;

__webpack_nonce__ = getNonce()
